export const SET_GOOGLE_ONBOARDING_STATE = 'SET_GOOGLE_ONBOARDING_STATE';

export const setGoogleOnboardingState = (payload) => (dispatch) =>
    dispatch({ type: SET_GOOGLE_ONBOARDING_STATE, payload });
